import { Injectable } from "@angular/core";
import { ErrorInterceptor } from "./ErrorInterceptor";
import { HttpClient } from "@angular/common/http";


declare let ENDPOINT_LUDYAPI: string;
declare let NAMESPACE_LUDYACCOUNT: string;

@Injectable()
export class MainHttp {

    constructor(private http: HttpClient,
        private errorInterceptor: ErrorInterceptor) {

    }

    getUserData(param?): Promise<any> {
        param = !param ? {} : param;
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "app/agent";
        let request = this.http.put(url,param);

        return new Promise((resolve, reject) => {
            request.subscribe((response:any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    getLoggedUserData(param?): Promise<any> {
        param = !param ? {} : param;
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "biz/agent/myself";
        let request = this.http.put(url,param);

        return new Promise((resolve, reject) => {
            request.subscribe((response:any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }
}

